(function (doc, win) { // 修改旋转状态下字体大小
  var docEl = doc.documentElement,
    resizeEvt = 'onorientationchange' in window ? 'onorientationchange' : 'resize',
    recalc = function () {
      var clientWidth = docEl.clientWidth
      if (!clientWidth) return
      if (clientWidth >= 750) {
        docEl.style.fontSize = '100px'
      } else {
        docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
      }
    }

  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, recalc, false) // false冒泡阶段，true捕获
  doc.addEventListener('DOMContentLoaded', recalc, false)
  // 当初始的 HTML 文档被完全加载和解析完成之后，
  // DOMContentLoaded 事件被触发，而无需等待样式表、图像和子框架的完成加载。
})(document, window)



// WEBPACK FOOTER //
// ./src/util/rem.js